import React from "react";
var __jsx = React.createElement;
import AwesomeIcon from "../AwesomeIcon";
var ExpandCollapseButton = function ExpandCollapseButton(_ref) {
  var onClick = _ref.onClick,
    title = _ref.title,
    icon = _ref.icon;
  return /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer w-6 h-6 flex items-center justify-center bg-gray-900 hover:bg-teal-700  dark:hover:bg-gray-600 rounded-lg transition-colors shadow-lg",
    onClick: onClick,
    title: title
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: icon,
    size: "sm",
    className: "text-gray-200"
  }));
};
export default ExpandCollapseButton;